<template>
  <single-image
    v-bind="$attrs"
    accept=".png,.jpg"
    :auth-token-storage-key="'token'"
    :jwt-body-key="'jwt'"
    :input-id="inputId"
    :schema="schema"
    :media-u-r-l="mediaURL"
    :query-string="queryString"
    @error="handleError"
  />
</template>

<script>
import { SingleImage } from '@witkac/vue-images';

import { uploadMixin } from '../../mixins/upload';

// @vuese
// @group Components/Forms
// Input na obrazki
export default {
  components: { SingleImage },
  mixins: [uploadMixin]
};
</script>
